"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bundleMerchandiseIds = bundleMerchandiseIds;
exports.isCmsHubSelected = exports.isAddonsSelected = exports.isGrowthSuiteSelection = exports.isMerchInGrowthSuite = exports.getMonthlyOfferIdForBundleCheckout = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _PurchaseMotionTypes = require("ui-addon-upgrades/_core/purchaseMotions/PurchaseMotionTypes");

var _HubMap = _interopRequireDefault(require("self-service-api/constants/HubMap"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

function bundleMerchandiseIds(_ref) {
  var marketingPlanSelected = _ref.marketingPlanSelected,
      salesPlanSelected = _ref.salesPlanSelected,
      servicePlanSelected = _ref.servicePlanSelected,
      cmsPlanSelected = _ref.cmsPlanSelected,
      _ref$selectedAddOns = _ref.selectedAddOns,
      selectedAddOns = _ref$selectedAddOns === void 0 ? [] : _ref$selectedAddOns,
      _ref$selectedServices = _ref.selectedServices,
      selectedServices = _ref$selectedServices === void 0 ? [] : _ref$selectedServices;
  var merchandiseIds = [];

  if (marketingPlanSelected) {
    merchandiseIds.push(marketingPlanSelected);
  }

  if (salesPlanSelected) {
    merchandiseIds.push(salesPlanSelected);
  }

  if (servicePlanSelected) {
    merchandiseIds.push(servicePlanSelected);
  }

  if (cmsPlanSelected) {
    merchandiseIds.push(cmsPlanSelected);
  }

  selectedAddOns.forEach(function (merchandiseId) {
    return merchandiseIds.push(merchandiseId);
  });
  selectedServices.forEach(function (merchandiseId) {
    return merchandiseIds.push(merchandiseId);
  });
  return merchandiseIds;
} // Returns the common monthly offer id for array of merchandise if there is one
// and if all selections are touchless-eligible.
// Null otherwise.


var getMonthlyOfferIdForBundleCheckout = function getMonthlyOfferIdForBundleCheckout(merchandiseIds, getPromotionsForMerch, getPurchaseMotionsForMerch) {
  if (!merchandiseIds.length) return null;
  var promotionsForBaseMerch = getPromotionsForMerch(merchandiseIds[0]);
  var baseOfferId = promotionsForBaseMerch && promotionsForBaseMerch.monthlyOfferId;
  var hasSharedOfferIdAndIsAllTouchless = merchandiseIds.every(function (merchId) {
    var promotionsForMerch = getPromotionsForMerch(merchId);
    var hasSharedOfferId = promotionsForMerch && promotionsForMerch.monthlyOfferId === baseOfferId;
    var canBuyTouchless = getPurchaseMotionsForMerch(merchId).includes(_PurchaseMotionTypes.BUY_TOUCHLESS);
    return hasSharedOfferId && canBuyTouchless;
  });
  return hasSharedOfferIdAndIsAllTouchless ? baseOfferId : null;
};

exports.getMonthlyOfferIdForBundleCheckout = getMonthlyOfferIdForBundleCheckout;

var isMerchInGrowthSuite = function isMerchInGrowthSuite(merchId) {
  var growthSuiteMerch = [].concat((0, _toConsumableArray2.default)(_HubMap.default[_Hubs.default.HUB_MARKETING].highlightedPaidMerch), (0, _toConsumableArray2.default)(_HubMap.default[_Hubs.default.HUB_MARKETING].highlightedPaidMerchMCBeta), (0, _toConsumableArray2.default)(_HubMap.default[_Hubs.default.HUB_SALES].highlightedPaidMerch), (0, _toConsumableArray2.default)(_HubMap.default[_Hubs.default.HUB_SERVICE].highlightedPaidMerch));
  return growthSuiteMerch.includes(merchId);
};

exports.isMerchInGrowthSuite = isMerchInGrowthSuite;

var isGrowthSuiteSelection = function isGrowthSuiteSelection(_ref2, merchandiseMap) {
  var marketingPlanSelected = _ref2.marketingPlanSelected,
      salesPlanSelected = _ref2.salesPlanSelected,
      servicePlanSelected = _ref2.servicePlanSelected;

  if (!marketingPlanSelected || !salesPlanSelected || !servicePlanSelected) {
    return false;
  }

  var areAllPlansSameEdition = merchandiseMap[marketingPlanSelected].edition === merchandiseMap[salesPlanSelected].edition && merchandiseMap[salesPlanSelected].edition === merchandiseMap[servicePlanSelected].edition;
  return areAllPlansSameEdition;
};

exports.isGrowthSuiteSelection = isGrowthSuiteSelection;

var isAddonsSelected = function isAddonsSelected(_ref3) {
  var _ref3$selectedAddOns = _ref3.selectedAddOns,
      selectedAddOns = _ref3$selectedAddOns === void 0 ? [] : _ref3$selectedAddOns;
  return selectedAddOns.length > 0;
};

exports.isAddonsSelected = isAddonsSelected;

var isCmsHubSelected = function isCmsHubSelected(_ref4) {
  var cmsPlanSelected = _ref4.cmsPlanSelected;
  return !!cmsPlanSelected;
};

exports.isCmsHubSelected = isCmsHubSelected;


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/utils.js
// module id = 221
// module chunks = 5 6 7